// Runtime configuration service
// This service provides access to environment-specific configuration
// that is loaded at runtime instead of being baked into the build
export class RuntimeConfigService {
    constructor() {
        // Check if runtime config is available
        if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
            this.config = window.__RUNTIME_CONFIG__;
        }
        else {
            // Fallback to default values if runtime config is not available
            // This can happen during development or testing
            this.config = {
                // WS_URL: 'wss://ws-staging.alphafi.xyz/ws', //'ws://localhost:8080/ws',
                WS_URL: 'ws://localhost:8083/ws',
                ALPHALEND_WS_URL: 'wss://ws-staging.alphalend.xyz/ws', //'ws://localhost:8084/ws',
                STSUI_WS_URL: 'wss://ws.stsui.com', // 'wss://dev.ws.stsui.com' for dev
                API_BASE_URL: 'https://api.alphafi.xyz',
                APR_URL: 'https://api.alphafi.xyz/apr',
                ENABLE_WEBSOCKET: true,
                DEFAULT_NETWORK: 'mainnet',
                MAINNET_GRPC_URL: '',
                TESTNET_GRPC_URL: '',
                DEVNET_GRPC_URL: '',
                MAINNET_GRPC_TOKEN: '',
                TESTNET_GRPC_TOKEN: '',
                DEVNET_GRPC_TOKEN: '',
                MAINNET_GRAPHQL_URL: '',
                TESTNET_GRAPHQL_URL: '',
                DEVNET_GRAPHQL_URL: '',
                LAZER_PROXY_URL: '',
                ENABLE_DEBUG_LOGS: false,
                MIXPANEL_TOKEN: '',
            };
        }
    }
    static getInstance() {
        if (!RuntimeConfigService.instance) {
            RuntimeConfigService.instance = new RuntimeConfigService();
        }
        return RuntimeConfigService.instance;
    }
    getConfig() {
        return this.config;
    }
    get(key) {
        return this.config[key];
    }
    // Convenience methods for common config values
    getWebSocketUrl() {
        return this.config.WS_URL;
    }
    getAlphalendWebSocketUrl() {
        return this.config.ALPHALEND_WS_URL;
    }
    getStsuiWebSocketUrl() {
        return this.config.STSUI_WS_URL;
    }
    getApiBaseUrl() {
        return this.config.API_BASE_URL;
    }
    isWebSocketEnabled() {
        return this.config.ENABLE_WEBSOCKET;
    }
    getDefaultNetwork() {
        return this.config.DEFAULT_NETWORK;
    }
    /** gRPC-web endpoint override for `network`, or '' when unset. */
    getGrpcUrl(network) {
        switch (network) {
            case 'mainnet':
                return this.config.MAINNET_GRPC_URL;
            case 'testnet':
                return this.config.TESTNET_GRPC_URL;
            case 'devnet':
                return this.config.DEVNET_GRPC_URL;
            default:
                return '';
        }
    }
    /** gRPC auth-token override for `network`, or '' when unset. */
    getGrpcToken(network) {
        switch (network) {
            case 'mainnet':
                return this.config.MAINNET_GRPC_TOKEN;
            case 'testnet':
                return this.config.TESTNET_GRPC_TOKEN;
            case 'devnet':
                return this.config.DEVNET_GRPC_TOKEN;
            default:
                return '';
        }
    }
    /** GraphQL endpoint override for `network`, or '' when unset. */
    getGraphqlUrl(network) {
        switch (network) {
            case 'mainnet':
                return this.config.MAINNET_GRAPHQL_URL;
            case 'testnet':
                return this.config.TESTNET_GRAPHQL_URL;
            case 'devnet':
                return this.config.DEVNET_GRAPHQL_URL;
            default:
                return '';
        }
    }
    /** Lazer price-proxy override, or '' when unset (use the SDK's own URL). */
    getLazerProxyUrl() {
        var _a;
        return (_a = this.config.LAZER_PROXY_URL) !== null && _a !== void 0 ? _a : '';
    }
    isDebugLogsEnabled() {
        return this.config.ENABLE_DEBUG_LOGS;
    }
    getAprUrl() {
        return this.config.APR_URL;
    }
    getMixpanelToken() {
        var _a;
        return (_a = this.config.MIXPANEL_TOKEN) !== null && _a !== void 0 ? _a : '';
    }
}
// Export a singleton instance
export const runtimeConfig = RuntimeConfigService.getInstance();
